import { IAssetPurchaseOrder, ISiteReccee } from '@api/models';
import { removeFileSiteRecce, updateFileSiteRecce } from '@api/services/site-recce.service';
import { useMutation } from '@tanstack/react-query';

export const useFileUploadSiteRecce = (
    clientInstallationId: string,
    projectInstallationId: string,
    initialData: ISiteReccee,
    setData: (data: any) => void
) => {
    const addFileMutation = useMutation({
        mutationFn: (payload: any) =>
            updateFileSiteRecce(clientInstallationId, projectInstallationId, initialData._id, payload),
        onSuccess: (updatedInstallation) => {
            // setData((prev: IClientInstallation) => ({
            //     ...prev,
            //     files: [...(prev.files || []), ...newFiles],
            //   }));
            setData(updatedInstallation);
        },
    });

    const removeFileMutation = useMutation({
        mutationFn: (fileId: string) =>
            removeFileSiteRecce(clientInstallationId, projectInstallationId, initialData._id, fileId),
        onSuccess: (updatedInstallation) => {
            // setData(updatedInstallation);
        },
    });

    const handleAddFiles = (files: FileList | null) => {
        if (!files) return;

        const formData = new FormData();
        Array.from(files).forEach((file) => {
            formData.append('file', file);
        });

        addFileMutation.mutate(formData);
    };

    const handleRemoveFile = (fileId: string) => {
        removeFileMutation.mutate(fileId);
        setData((prev: IAssetPurchaseOrder) => {
            const updatedFiles = prev.files?.filter((file: any) => file._id !== fileId) || [];
            return { ...prev, files: updatedFiles };
        });
    };

    return {
        handleAddFiles,
        handleRemoveFile,
        isUploading: addFileMutation.isLoading,
        isRemoving: removeFileMutation.isLoading,
    };
};
